import { isFunction } from '@pct-ts/typeguard';
import { showUnknownErrorDialog } from '../show-unknown-error-dialog';
import { HandledErrorResponse } from './handled-error-response';

export function handleHttpError(afterHandler?: (error: unknown) => void): (error: unknown) => void {
  return (error: unknown) => {
    // TODO handle swagger exception
    if (!(error instanceof HandledErrorResponse)) {
      console.error(error);
      showUnknownErrorDialog(afterHandler, undefined, error);
    } else {
      if (isFunction(afterHandler)) {
        afterHandler(error);
      }
    }
  };
}
